import angular from 'angular';

class LadproviderDetails {
  /** create, update, detail. */

  /*@ngInject*/
  constructor(toastr, $translate, LadProviderService, $state, IndicatorService) {
    this.toastr = toastr;
    this.$translate = $translate;
    this.formDisabled = true;
    this.LadProviderService = LadProviderService;
    this.$state = $state;
    this.IndicatorService = IndicatorService;
  }

  $onInit() {
    let vm = this;
    vm.includes = {
      errorMessages: require('../../../app/layouts/error-messages.html')
    };
    if (!vm.ladprovider) {
      vm.ladprovider = {};
      vm.mode = 'creation';
      vm.enableForm();
    } else {
      vm.IndicatorService.countFileProcessedByLad({ ladId: vm.$state.params.guid, hours: 24 }).$promise.then(function(
        data
      ) {
        vm.fileProcessedOneDay = data.value;
      });
      vm.IndicatorService.countFileProcessedByLad({ ladId: vm.$state.params.guid, hours: 168 }).$promise.then(function(
        data
      ) {
        vm.fileProcessedOneWeek = data.value;
      });
      vm.IndicatorService.countFileProcessedByLad({ ladId: vm.$state.params.guid, hours: 744 }).$promise.then(function(
        data
      ) {
        vm.fileProcessedOneMonth = data.value;
      });
    }
  }

  enableForm() {
    this.formDisabled = false;
  }

  save() {
    var ctrl = this;
    if (ctrl.form.$valid) {
      if (ctrl.ladprovider.containerModeRestriction === '') {
        ctrl.ladprovider.containerModeRestriction = null;
      }
      ctrl.ladprovider.eId = ctrl.ladprovider.eId.toUpperCase();
      this.LadProviderService.save(this.ladprovider).$promise.then(
        function() {
          ctrl.toastr.success(ctrl.$translate.instant('commons.saved'));
          ctrl.formDisabled = true;
          if (ctrl.mode === 'creation') {
            ctrl.$state.go('app.ladprovider.list');
          } else {
            ctrl.mode = 'details';
          }
        },
        function(error) {
          ctrl.toastr.error('Echec de sauvegarde', error);
        }
      );
    }
  }
}

angular.module('app.ladprovider').component('ladproviderDetails', {
  templateUrl: require('./ladprovider-details.html'),
  controller: LadproviderDetails,
  bindings: {
    ladprovider: '<'
  }
});
